import styled from 'styled-components';

type LinkProps = {
	id: string;
	to: string;
	label?: string;
	icon?: string;
};

interface NavigationProps {
	className?: string;
	links: LinkProps[];
}

const Link = styled.a`
	${({ theme }) => theme.button({ size: 'small' })};
`;

const IconLink = styled.a<{ $iconName: string }>`
	${({ theme, $iconName }) => theme.iconButton({ icon: { name: $iconName, color: '#888' } })};
`;

export const Navigation = ({ className, links }: NavigationProps) =>
	<nav className={className}>
		{links.map(link => link.icon
			? <IconLink key={link.id} $iconName={link.icon} href={link.to} />
			: <Link key={link.id} href={link.to}>{link.label}</Link>
		)}
	</nav>